import { createRoot } from 'react-dom/client';
import './app/dayjsConfig'; // Initialize dayjs plugins
import 'mapbox-gl/dist/mapbox-gl.css';
import './assets/css/index.css';

import {
  init as sentryInit,
  replayIntegration,
  browserTracingIntegration,
  replayCanvasIntegration,
  browserProfilingIntegration,
  launchDarklyIntegration,
} from '@sentry/react';

import { getAppConfig } from './app/config';
import { rootOptions } from './app/rootOptions';
import { Root } from './Root';

const { sentryDsn, environment } = getAppConfig();

const integrations = [
  browserTracingIntegration(),
  replayIntegration({
    maskAllText: false,
    maskAllInputs: false, // Credentials are not entered into the app (instead, at the IAP login page) and so we're okay here.
    networkDetailAllowUrls: ['app.overstory.com'],
    networkResponseHeaders: ['Via', 'Server', 'X-Forwarded-For', 'X-Cache'],
    unblock: ['svg'],
  }),
  replayCanvasIntegration(),
  launchDarklyIntegration(),
];

// Testing this on staging to validate no perf issues by adding this in.
if (environment !== 'production') {
  integrations.push(browserProfilingIntegration());
}

if (sentryDsn) {
  sentryInit({
    dsn: sentryDsn,
    integrations,
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      // Match overstory.com URLs but exclude auth.* subdomains to avoid CORS issues with Descope
      /^https:\/\/(?!auth\.).*\.overstory\.com/,
    ],
    environment,

    // Session Replay
    replaysSessionSampleRate: environment === 'production' ? 1.0 : 0.0, // Sample all sessions on prod for now, disable elsewhere.
    replaysOnErrorSampleRate: 1.0, // But always capture when there are errors.
  });
}

const container = document.getElementById('root');
const root = createRoot(container!, rootOptions);
root.render(<Root />);
